import React from 'react'
import {
  Box,
  Divider,
  Menu,
  MenuButton,
  MenuList,
  MenuDivider,
  Drawer,
  DrawerContent,
  DrawerBody,
  DrawerOverlay,
  DrawerCloseButton,
  DrawerHeader,
  useDisclosure
} from '@chakra-ui/react'

import AccountButton from './sub/AccountButton'
import AccountResources from './sub/AccountResources'
import AccountContent from './sub/AccountContent'

function AccountNav() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>
      <AccountButton as="button" display={{ base: 'flex', md: 'none' }} onClick={() => onOpen()} />
      <Drawer
        autoFocus={false}
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        returnFocusOnClose={true}
        onOverlayClick={onClose}
        size="xs"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton onClick={onClose} />
          <DrawerHeader>Available resources</DrawerHeader>
          <Divider />
          <DrawerBody>
            <Box px="2" py="2">
              <AccountResources />
            </Box>
            <Divider />
            <AccountContent type="drawer" />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <Box>
        <Menu isLazy placement="bottom-end">
          <AccountButton
            as={MenuButton}
            display={{ base: 'none', md: 'flex' }}
            _focus={{ boxShadow: 'none' }}
            tour="account-nav"
          />
          <MenuList>
            <AccountResources />
            <MenuDivider />
            <AccountContent type="menu" />
          </MenuList>
        </Menu>
      </Box>
    </>
  )
}

export default AccountNav
